import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState, FORM_MODE, AppNotifications, LanguageOutputModel, BlogStatus, BlogCategoryApiOutputModel, TCb } from "../../../models";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./CategoryForm.type";
import { withRouter } from "react-router-dom";
import { NotificationActions } from "../../../store/actions";
import CategoryFormPresenter from "./CategoryForm.presenter";
import { loadCallback } from "../../../utils";
import { BlogService } from "../../../services";
class CategoryFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    // const mode = this.props.initial ? FORM_MODE.EDIT : FORM_MODE.CREATE;

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      languageOptions: this.props.all_language_list.data,
      activeLang: this.props.all_language_list.data.find(
        (e: LanguageOutputModel) => e.isPrimary
      )?.id,
      categoryStatus: false,
    };
  }

  onSubmit = (val: any) => {

    let newArr: any[] = [];
    this.state.languageOptions.forEach((e) => {
      let newObj = {
        languageId: e.id,
        title: val[`title${e.id}`] || null,
        link: val.link,
        type: this.props.categoryType
    };
    const found = this.state.initData?.find((i) => i.languageId === e.id) || false;
    this.state.mode !== FORM_MODE.CREATE &&
      found &&
      Object.assign(newObj, {
        id: this.state.initData?.find((i) => i.languageId === e.id)?.id,
      });
            
      newArr.push(newObj);
    })

    const status = this.state.categoryStatus ? BlogStatus.PUBLISH : BlogStatus.UNPUBLISH;

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateCategory(newArr, status);
    } else {
      this.onUpdateCategory(newArr, status);
    }
  };
  onCreateCategory = (data, status) => {
    BlogService.createCategory(data, {status: status})
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create category success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Create category failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Create category failed",
        });
      });
  };
  onUpdateCategory = (data, status) => {
    BlogService.updateCategory(this.props.categoryCode!, data, {status: status})
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Edit category success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Edit category failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Edit category failed",
        });
      });
  };

  onDeleteCategory = () => {
    BlogService.deleteCategory(this.props.categoryCode!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete category success",
          });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete category failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete category failed",
        });
      });
  };

  onLoadCategoryDetail = (code: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      BlogService.getCategoryByCode(code)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: BlogCategoryApiOutputModel[] = res.data.data;

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                loading: false,
                initData: data,
                categoryStatus: data[0].status === BlogStatus.PUBLISH
              },
              () => {
                loadCallback(cb?.success);
              }
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Failed to load data",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Failed to load data",
          });
        });
    });
  };

  onChangeLanguage = (id: string) => {
    this.setState({ activeLang: id });
  };

  onChangeCategoryStatus = (status: boolean) => {
    this.setState({ categoryStatus: status });
  }

  render() {
    return (
      <>
        <CategoryFormPresenter
          {...this.props}
          {...this.state}
          onSubmit={this.onSubmit}
          onDeleteCategory={this.onDeleteCategory}
          onChangeLanguage={this.onChangeLanguage}
          onChangeCategoryStatus={this.onChangeCategoryStatus}
        />
      </>
    );
  }

  componentDidMount =() => {
    if (this.props.categoryCode) {
      this.onLoadCategoryDetail(this.props.categoryCode, {
        success: () => {},
      });
    }
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(CategoryFormContainer)
);
